import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_intro-security",
  "use": "svg_intro-security-usage",
  "viewBox": "0 0 24 27",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 27\" id=\"svg_intro-security\"><path d=\"M12 13a3.5 3.5 0 0 0-1 6.854V22a1 1 0 0 0 2 0v-2.146A3.5 3.5 0 0 0 12 13Zm0 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm10-9h-4V6A6 6 0 1 0 6 6v3H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2ZM8 6a4 4 0 0 1 8 0v3H8V6Zm14 19H2V11h20v14Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol